import { render } from "./FileSystemObject.vue?vue&type=template&id=6293b78f&scoped=true&ts=true"
import script from "./FileSystemObject.vue?vue&type=script&lang=ts"
export * from "./FileSystemObject.vue?vue&type=script&lang=ts"

import "./FileSystemObject.vue?vue&type=style&index=0&id=6293b78f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6293b78f"]])

export default __exports__